import React from "react";
import { Button, Label } from "semantic-ui-react";
import useEventDetailsStatuses from "@hooks/useEventDetailsStatuses";
import useComplianceView from "@hooks/useComplianceView";

const EventDetailsStatuses = () => {
  const { isLoading } = useComplianceView();
  const { onStatusChange, selectedStatuses, status, statusCounts } =
    useEventDetailsStatuses();

  return (
    <Label.Group style={{ display: "inline-block" }}>
      {status.map((label, index) => {
        return (
          <Label
            as={Button}
            color={label.colour.toLowerCase()}
            disabled={isLoading}
            basic={!selectedStatuses.includes(label.id)}
            className="clickable"
            onClick={() => onStatusChange(label)}
            style={{ border: "1px solid" }}
          >
            {label.name}
            <Label.Detail>{statusCounts[index]?.count ?? 0}</Label.Detail>
          </Label>
        );
      })}
    </Label.Group>
  );
};

export default EventDetailsStatuses;
